import type { ReactElement } from "react";

import { GlobalSearchProvider } from "@/components/layout/GlobalSearch";
import { PageSuspense } from "@/components/shared/PageSuspense";
import { PermissionGate } from "@/components/shared/PermissionGate";

/**
 * Full-viewport shell for focused flows. Top brand bar (logo · title · close) lives in
 * {@link FormFlow} when `variant="fullscreen"` so it stays aligned with the form column.
 */
export function FormFlowShell(): ReactElement {
  return (
    <GlobalSearchProvider>
      <div
        className="fixed inset-0 z-50 flex h-dvh max-h-dvh flex-col overflow-hidden bg-background text-foreground"
        data-slot="form-flow-shell"
      >
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
          <PageSuspense layout="fullscreen">
            <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
              <PermissionGate />
            </div>
          </PageSuspense>
        </div>
      </div>
    </GlobalSearchProvider>
  );
}
